import styled from 'styled-components';

export const MappingRuleTitle = styled.span`
  font-weight: 500;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.65);
`;
